import * as React from 'react';
import './styles/lesson_schedule';
import t from './locales';
import Button from "../Shared/Button";

/* Types  */

interface IProps {
  selectedDateList?: Date[];
  stockIntegration?: string;
  snowItemId: number;
  isTimeScheduleShown: boolean;
  handleLessonScheduleSelect: Function;
  handleLessonScheduleClose: Function;
}

interface IState {
  timeScheduleList: Object[];
  isLoading: boolean;
}

/* React Component  */

class SnowItemLessonStock extends React.Component<IProps, IState> {
  static defaultProps = {}

  constructor(props: IProps) {
    super(props);
    this.state = {
      timeScheduleList: [],
      isLoading: false,
    }
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    const { selectedDateList, stockIntegration, snowItemId } = this.props;

    if(stockIntegration == null || selectedDateList[0] == null || selectedDateList.length > 1 || selectedDateList[0] === prevProps.selectedDateList[0]){
      return;
    }

    const date = selectedDateList[0];

    this.setState({ isLoading: true }, () => {
      fetch(`/snow/api/v1/stock_integration/lesson/${stockIntegration}/${snowItemId}?date=${date}`)
        .then(data => data.json())
        .then((json) => {
          const timeScheduleList = json['time_schedules'];
          this.setState({timeScheduleList, isLoading: false});
        })
        .catch((error) => {
          console.error(error)
          const timeScheduleList = [];
          this.setState({timeScheduleList, isLoading: false});
        })
    });
  }

  handleScheduleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const { handleLessonScheduleSelect } = this.props;
    const timeSchedule: string = event.currentTarget.getAttribute('data-time-schedule');
    if(timeSchedule == null){
      return;
    }

    handleLessonScheduleSelect(timeSchedule);
  }

  renderSchedules() {
    const { isTimeScheduleShown } = this.props;
    const { timeScheduleList, isLoading } = this.state;

    if (!isTimeScheduleShown){
      return null;
    }

    const result = [];
    if (timeScheduleList.length > 0){
      result.push(
        <div className="alert alert-success" key="alert-success">
          {t.lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule()}
        </div>
      )

      for(let timeSchedule of timeScheduleList){
        result.push(
          <div className="lesson-schedule" key={timeSchedule['reserve_code']}>
            <a
              href="#"
              className="btn btn-block btn-outline-secondary"
              onClick={this.handleScheduleClick}
              data-time-schedule={timeSchedule['time_schedule']}
            >
              {timeSchedule['time_schedule']}
            </a>
          </div>
        )
      }
    }else{
      result.push(
        <div className="alert alert-warning" key="alert-warning">
          {t.sorryWeCouldNotFindAnyLessonAvailableOnTheDate()}
        </div>
      )
    }

    result.push(
      <div key="back-button">
        <Button href="#" onClick={this.handleBackClick}>
          {t.back()}
        </Button>
      </div>
    )

    return(
      <div className="lesson-schedule-area">
        {isLoading ? <div className="lesson-loading-area"><div className="lesson-loading-icon" /></div> : result}
      </div>
    );
  }

  handleBackClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const { handleLessonScheduleClose } = this.props;
    handleLessonScheduleClose();
  }

  render() {
    const { selectedDateList } = this.props;

    if (selectedDateList.length == 0){
      return null;
    }

    return (
      <div>
        <div>{this.renderSchedules()}</div>
      </div>
    );
  }
}

export default SnowItemLessonStock;
